import { render, staticRenderFns } from "./ThemeCustomizer.vue?vue&type=template&id=356c8b4e&"
import script from "./ThemeCustomizer.vue?vue&type=script&lang=js&"
export * from "./ThemeCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ThemeCustomizer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports